export default "__VITE_ASSET__azwMU22K__"